<article class="comment">
    <label for="comment-field" class="comment-label">{{title}}</label>
    <textarea id="comment-field" class="comment-field" name="Kommentarfelt" [value]="value" (change)="valueChange.emit(value)"></textarea>
</article>